import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import SafeMarkdown from '../../shared/SafeMarkdown';
import { assistantPrimaryButtonSx, assistantSecondaryButtonSx, assistantTextButtonSx } from '../../freestyle/assistantButtonStyles';
import { colors } from '../../../designTokens';

export default function KnowledgeSuggestionCard({
  suggestion = '',
  onAddKnowledge,
  onAttachExisting,
  onReevaluate,
  onDone,
  doneLabel = 'Done',
  onSkip,
  analyzing = false,
  showReevaluate = false,
  nextStep = 'finish',
}) {
  const nextStepCopy = nextStep === 'done'
    ? {
      title: 'Ready to continue?',
      description: `Add any helpful knowledge, then select ${doneLabel} when you are ready to continue.`,
    }
    : {
      title: 'Ready to finish this capability?',
      description: `Add helpful knowledge, then select ${doneLabel} to generate the details and variables that make it ready to reuse.`,
    };

  return (
    <Stack spacing={1.25} sx={{ mt: 1.5 }}>
      <Typography component="h3" sx={{ fontSize: '1rem', fontWeight: 750, letterSpacing: '-0.015em' }}>
        Knowledge recommendations
      </Typography>
      {analyzing ? (
        <Typography variant="body2" color="text.secondary">
          Analyzing knowledge gaps…
        </Typography>
      ) : (
        <SafeMarkdown>{suggestion}</SafeMarkdown>
      )}
      {!analyzing && (
        <Box
          sx={{
            px: 1.25,
            py: 1.1,
            border: '1px solid rgba(29, 78, 216, 0.14)',
            borderRadius: '8px',
            bgcolor: 'rgba(29, 78, 216, 0.025)',
          }}
        >
          <Typography sx={{ color: colors.textPrimary, fontSize: '0.8125rem', fontWeight: 750 }}>
            {nextStepCopy.title}
          </Typography>
          <Typography sx={{ mt: 0.25, color: colors.textSecondary, fontSize: '0.8125rem', lineHeight: 1.45 }}>
            {nextStepCopy.description}
          </Typography>
        </Box>
      )}
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {onAddKnowledge && (
          <Button size="small" variant="contained" onClick={onAddKnowledge} sx={assistantPrimaryButtonSx}>
            Create knowledge
          </Button>
        )}
        {onAttachExisting && (
          <Button size="small" variant="outlined" onClick={onAttachExisting} sx={assistantSecondaryButtonSx}>
            Attach existing knowledge
          </Button>
        )}
        {showReevaluate && onReevaluate && (
          <Button size="small" onClick={onReevaluate} sx={assistantTextButtonSx}>
            Re-evaluate
          </Button>
        )}
        {onDone && (
          <Button size="small" variant="outlined" onClick={onDone} sx={assistantSecondaryButtonSx}>
            {doneLabel}
          </Button>
        )}
        {onSkip && (
          <Button size="small" onClick={onSkip} sx={assistantTextButtonSx}>
            Skip
          </Button>
        )}
      </Stack>
    </Stack>
  );
}
